import React, { Component } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import moment from 'moment/moment'
import _ from 'lodash'
import { UploadOutlined } from '@ant-design/icons';
import { FormUtils as GetAllFormFields } from 'sz-react-utils'

import {
    Card,
    Tooltip,
    Button,
    Drawer,
    Row,
    Col,
    Select,
    DatePicker,
    Table,
    Form,
    notification
} from "antd";

import Request, { API_URL } from '../../../../request'

import { connect } from 'react-redux'

import styles from './styles.less'
import common from '../../../common.less'
import Settings from '../../../../components/_utils/settings'
import { RightsWrapper } from "../../../../components/_utils/utils";
import ShowGeneratedInvoice from '../../../../components/pdf/showGeneratedInvoice'

import lodash from 'lodash'
import { aY } from '@fullcalendar/core/internal-common'

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let userCheckBox = {}
let localUser = JSON.parse(localStorage.getItem('user'))

const Option = Select.Option

let desks = {
    'Front Desk': '/desk/update-counselling',
    'Registration Desk': '/registration/fees',
    'Application Desk': '/desk/allApplication-desk/update',
    'Visa Desk': '/desk/getVisa',
    'Claim Desk': '/desk/getClaim',
    'Operation Manager Desk': '/operation-manager-inquiry/update'
};
@Form.create()
class SubAgentStudents extends Component {
    state = {
        count: 0,
        followDuesCount: 0,
        showFollowUp: false,
        showRecentInvoices: false,
        studentId: null,
        studentSearchId: '',
        allBranches: [],
        allSubAgents: [],
        counsellorId: '',
        counsellors: [],
        recentInvoices: [],
        channelPartnerList: [],
        selectMultipleRecords: [],
        showCompanyDetailForm: false,
        enableBTN: false,
        deskColor: null,
        ratingArr: ['Fit2Apply', 'Potential', 'Luke Warm', 'Cold', 'Dead'],
        leadSourceList: ['University', 'Channel Partner'],
        studentStatusList: ['Not Enrolled Yet', 'Ongoing', 'Max Commission Paid', 'Withdrawn - Bad Debts'],
        invoiceStatusList: ['Not Enrolled Yet', 'Enrolled Now', 'Ongoing', 'Max Commission Paid', 'Withdrawn - Bad Debts', 'To Be Invoiced', 'Invoice Processed-Term 1', 'Invoice Processed-Term 2', 'Invoice Processed-Term 3', 'Invoice Processed-Term 4', 'Invoice Processed-Term 5'],
        drawerTodayPastInvoices: true,
        paymentBalance: [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ],
        showPayNow: false,
        isFollowUpOverdue: false,
        showSMS: false,
        showWhatsAppSms: false,
        showEmail: false,
        userCheckBox: {},
        universities: [],
        channelPartners: [],
        universityInstitutionName: '',
        channelPartnerId: '',
        invoiceStatus: '',
        associativePartnerId: '',
        studentBranchId: '',
        showReceiptDetails: false,
        showGeneratedInvoiceData: false,
        currentEditRecord: null,
        invoiceDates: [],
        generatedInvoice: null,
        loading: false
    }

    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] === undefined) {
            cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked;
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    chooseRangerPickerInvoiceDesk = (date, dateString) => {
        this.setState(
            {
                generationDate: dateString
            }, () => {
                this.table.current.reload();
            }
        )
    }
    onOk = value => {
        this.table.current.reload()
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            // params.count = 200

            if (!params.sortField) {
                params.sortField = 'moveDeskDate.moveToClaimDesk'
                params.sortOrder = 'descend'
            }

            if (this.state.counsellorId) {
                params.counsellorId = this.state.counsellorId
                params.page = 1
            }
            if (this.state.studentSearchId) {
                params.studentSearchId = this.state.studentSearchId
                params.page = 1
            } else {
                params.studentSearchId = '';
            }

            if (this.state.invoiceStatus) {
                params.invoiceStatus = this.state.invoiceStatus;
            }

            if (this.state.universityInstitutionName) {
                params["visaDesk.selectedCourse.universityId"] = this.state.universityInstitutionName;
            }
            if (this.state.channelPartnerId) {
                params["visaDesk.channelPartnerId"] = this.state.channelPartnerId;
            }
            if (this.state.generationDate) {
                params.generationDate = this.state.generationDate;
            }
            if (this.state.associativePartnerId) {
                params["associativePartnerId"] = this.state.associativePartnerId;
            }
            if (this.state.studentBranchId) {
                params["studentBranchId"] = this.state.studentBranchId;
            }

            if (params.dateOfBirth && params.dateOfBirth.length > 0) {
                var splitDate = params.dateOfBirth[0].split('-');
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var monthName = monthNames[splitDate[1] - 1];

                params.dateOfBirth = splitDate[0] + '-' + monthName + '-' + splitDate[2];

                const stringToDate = new Date(params.dateOfBirth);
                params.dateOfBirth = {
                    $gte: stringToDate.setHours(0, 0, 0),
                    $lt: stringToDate.setHours(23, 59, 59),
                };
            } else {
                delete params.dateOfBirth
            }

            if (this.state.isFollowUpOverdue) {
                params.isFollowUpOverdue = this.state.isFollowUpOverdue;
            }

            params.atLevel = ['subAgentStudents']
            let data = await Request.loadCounselling({
                ...params,
                dateFilter: this.state.time,
                regExFilters: ['studentName', 'email', 'mobile', 'updatedByUser.name', 'createdByUser.name', 'instituteStudentId']
            })

            delete data.error
            delete data.type

            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            this.setState({ count: data.total, followDuesCount: data.followUpsDuesCount, allBranches: data.allBranches, allSubAgents: data.allSubAgents, userCheckBox: userCheckBox })
            resolve(data)
        })
    }
    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    renderStatus = (record) => {
        let val = 'Ongoing';
        if (record.atLevel == 'Operation Manager Desk') {
            val = 'Not Enrolled Yet';
        } else if (record.atLevel == 'Front Desk') {
            val = 'Ongoing';
        } else if (['Registration Desk', 'Application Desk', 'Visa Desk'].includes(record.atLevel)) {
            val = 'Enrolled Now';
        } else if (record.atLevel == 'Claim Desk') {
            val = 'To Be Invoiced';
            let term = 0;
            if (record.nextInvoiceGenerationDates && record.nextInvoiceGenerationDates.length > 0) {
                record.nextInvoiceGenerationDates.map((generatedDate, index) => {
                    if (generatedDate.invoiceGenerated == true && generatedDate.invoiceGeneratedNumber) {
                        term = generatedDate.invoiceNo;
                    }
                })
                if (term > 0) {
                    if (record.nextInvoiceGenerationDates.length == term) {
                        val = 'Max Commission Paid';
                    } else {
                        val = 'Invoice Processed-Term ' + term;
                    }
                } else {
                    val = 'To Be Invoiced';
                }
            }
        } else if (record.atLevel == 'Archive Desk') {
            val = 'Commission Paid Done';
        } else if (['Dead Inquiry', 'Deleted'].includes(record.atLevel)) {
            val = 'Withdrawn - Bad Debts';
        }

        if (val === 'Ongoing' || val === 'Invoice Processed-Term 1' || val === 'Enrolled Now') {
            return <div className={styles.Ongoing}>{val}</div>
        }
        if (val === 'Not Enrolled Yet' || val === 'Invoice Processed-Term 4') {
            return <div className={styles.notEnrolled}>{val}</div>
        }

        if (val === 'Max Commission Paid' || val === 'Commission Paid Done' || val === 'Invoice Processed-Term 2') {
            return <div className={styles.maxCommission}>{val}</div>
        }

        if (val === 'Withdrawn - Bad Debts' || val === 'Invoice Processed-Term 3') {
            return <div className={styles.withdrawn}>{val}</div>
        }
        if (val === 'To Be Invoiced') {
            return <div className={styles.Invoiced}>{val}</div>
        }
        if (val === 'Invoice Processed-Term 5') {
            return <div className={styles.Term5}>{val}</div>
        }
    }

    loadChannelPartners = async () => {
        let { data: channelPartnerList } = await Request.getSimplePartners({
            results: 10000,
            sortField: 'channelPartnerName',
            sortOrder: 'ascend'
        })
        let channelPartners = channelPartnerList.reduce((temp, vv) => {
            temp.push({ _id: vv._id._id, display: vv.channelPartnerName })
            return temp
        }, [])

        this.setState({ channelPartners });
    }

    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ universities: resp.arr });
            })
            .catch(err => {
                console.log(err)
            })
    }

    async componentDidMount() {
        await this.loadUniversity();
        await this.loadChannelPartners();
    }

    componentWillMount() {
        this.setState({ deskColor: Settings.deskColor('Claim Desk') })
    }
    showCurrentRecord = async (inquiryId) => {
        let { doc } = await Request.getInquiry(inquiryId)
        if (doc) {
            this.setState({
                invoiceDates: doc.nextInvoiceGenerationDates && doc.nextInvoiceGenerationDates.length ? doc.nextInvoiceGenerationDates : [],
                currentEditRecord: doc,
                showReceiptDetails: true
            })
        }
    }
    returnDeskName = (record) => {
        const deskConfig = Settings.allDesks;

        let findIn = lodash.find(deskConfig, (rr) => {
            return rr.name == record.atLevel;
        });

        if (findIn) {
            return (
                <div
                    style={{
                        backgroundColor: findIn.color,
                        color: "white",
                        padding: 3,
                        display: "inline-block",
                        fontWeight: "bold",
                    }}
                >
                    {
                        localUser.isFinanceAdmin || localUser.isFinanceAdmin ?
                            <a
                                style={{ color: 'white' }}
                                size={"small"}
                                href={(record.atLevel && desks[record.atLevel] ? desks[record.atLevel] : 'documents') + "?id=" + record._id}
                            >{Settings.deskNameObj[record.atLevel]}</a>
                            :
                            Settings.deskNameObj[record.atLevel]
                    }
                </div>
            );
        } else {
            return <div>{record.atLevel}</div>;
        }
    };
    loadInvoiceDetail = async (invoiceId) => {
        const res = await Request.getInvoiceDetail(invoiceId);
        if (!res.error) {
            this.setState({ generatedInvoice: res.doc });
        }
    }
    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                valData.studentId = this.state.studentId;
                valData.invoiceGeneratedId = this.state.invoiceGeneratedId;
                this.setState({ loading: true })
                let response = await Request.updateAPinvoiceInfo(valData);
                this.setState({ loading: false })
                if (response.error) {
                    notification.error({
                        message: 'Error Saving',
                        description: 'Error while saving Data'
                    })
                } else {
                    notification.success({
                        message: 'Success',
                        description: 'Saved Successfully'
                    })
                    this.showCurrentRecord(this.state.studentId)
                    this.setState({
                        showGeneratedInvoiceData: false,
                        studentId: '',
                        invoiceGeneratedId: '',
                    })
                }
            }
        })
    }

    render() {
        const {
            allSubAgents,
            invoiceStatusList,
            channelPartners,
            universities,
            currentEditRecord,
            invoiceDates,
            generatedInvoice,
            showGeneratedInvoiceData,
        } = this.state

        const { dispatch, form } = this.props
        const {
            form: { getFieldDecorator }
        } = this.props

        const columns = [
            {
                title: 'Action',
                key: 'operation',
                width: 120,
                render: (text, record) => {
                    return (
                        <div>
                            <RightsWrapper myRight={"subAgentStudents.edit"}>
                                <Tooltip title="Upload Receipt">
                                    <Button
                                        size={'small'}
                                        shape="circle"
                                        onClick={() => {
                                            this.showCurrentRecord(record._id)
                                        }}
                                        icon="edit" />
                                </Tooltip>
                            </RightsWrapper>
                        </div>
                    )
                }
            },
            {
                title: 'VID',
                key: 'id',
                dataIndex: 'id',
                width: 120,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name',
                key: 'studentName',
                dataIndex: 'studentName',
                width: 110,
                searchTextName: 'studentName',
                filterRegex: true,
            },
            {
                title: 'DOB ',
                width: 100,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchTextName: 'D-M-Y',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format(dateFormat)
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Passport No',
                key: 'passportNo',
                searchTextName: 'passportNo',
                filterRegex: true,
                width: 100,
                dataIndex: 'visaDesk.passportNo'
            },
            {
                title: 'Institute Student Id',
                key: 'instituteStudentId',
                dataIndex: 'instituteStudentId',
                searchTextName: 'instituteStudentId',
                filterRegex: true,
                render: (item, record) => {
                    return record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.instituteStudentId ? record.visaDesk.selectedCourse.instituteStudentId : record.instituteStudentId ? record.instituteStudentId : ''
                },
                width: 120
            },
            {
                title: "At Stage",
                key: "atLevel",
                dataIndex: "atLevel",
                width: 110,
                sorter: true,
                render: (val, record) => {
                    return this.returnDeskName(record);
                },
            },
            {
                title: 'Student Status',
                key: 'nextInvoiceGenerationDates',
                width: 120,
                dataIndex: 'nextInvoiceGenerationDates',
                render: (text, record) => {
                    return this.renderStatus(record)
                }
            },
            {
                title: 'Branch',
                key: 'studentBranchId',
                width: 100,
                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Sub Agent',
                key: 'associativePartnerId',
                dataIndex: 'associativePartnerId',
                width: 100,
                filters: allSubAgents,
                render: (text, record) => {
                    return (
                        <div>
                            {record.associativePartnerId ? record.associativePartnerId.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Registration Date',
                key: 'moveDeskDate.moveToRegistrationDesk',
                dataIndex: 'moveDeskDate.moveToRegistrationDesk',
                width: 140,
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('lll') : ''}
                        </div>
                    )
                }
            },
            {
                title: "Processed By",
                key: 'processedBy',
                dataIndex: 'processedBy',
                width: 120,
            },
            {
                title: "Source",
                key: 'location',
                dataIndex: 'location',
                width: 120,
            },
            {
                title: 'Course',
                key: 'visaDesk.selectedCourse.courseName',
                width: 250,
                render: (text, record) => {
                    return (<div>
                        <div>{text ? text : ''}</div>
                    </div>)
                }
            },
            {
                title: 'University',
                key: 'visaDesk.selectedCourse.universityInstitutionName',
                width: 250,
                render: (text, record) => {
                    return (<div>
                        <div>{text ? text : ''}</div>
                    </div>)
                }
            },
            {
                title: 'Campus',
                key: 'visaDesk.selectedCourse.campusName',
                width: 250,
                render: (text, record) => {
                    return (<div>
                        <div>{text ? text : ''}</div>
                    </div>)
                }
            },
            {
                title: 'Start Date',
                key: 'visaDesk.courseStartDate',
                width: 100,
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('DD-MMM-YYYY') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Arrival Date',
                key: 'visaDesk.arrivalDate',
                width: 100,
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('DD-MMM-YYYY') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Transfered Date',
                key: 'moveDeskDate.moveToClaimDesk',
                dataIndex: 'moveDeskDate.moveToClaimDesk',
                width: 140,
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('lll') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            }
        ];
        let generatedInvoicesList = [];
        if (currentEditRecord && currentEditRecord.generatedInvoices != undefined && currentEditRecord.generatedInvoices && currentEditRecord.generatedInvoices.length > 0) {
            currentEditRecord.generatedInvoices.map((invoice) => {
                generatedInvoicesList[invoice.invoiceNumber] = invoice;
            })
        }
        const invoiceColumns = [
            {
                title: 'Term No',
                key: 'invoiceNo',
                render: (item, record, key) => {
                    return key + 1
                }
            },
            {
                title: 'View Invoice',
                key: 'invoiceGeneratedNumber',
                render: (item, record, key) => {
                    let invoiceStatusClass = '#ffcc00';
                    if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined) {
                        if (['Paid by Uni', 'Cleared'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = 'green';
                        } else if (['Approved by Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = 'blue';
                        } else if (['Generated', 'Submitted to Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = '#ffcc00';
                        }
                    }
                    return (
                        <React.Fragment>
                            <div >
                                <Tooltip title="View Invoice Details">
                                    {
                                        record.invoiceGeneratedNumber ?
                                            <Button style={{ backgroundColor: invoiceStatusClass, color: 'white' }} onClick={() => { this.loadInvoiceDetail(record.invoiceGeneratedNumber) }}>
                                                {record.invoiceGeneratedNumber}
                                            </Button>
                                            : 'To Be Issued'
                                    }

                                </Tooltip>
                            </div>
                        </React.Fragment>
                    );
                }
            },
            {
                title: 'Invoice Generation Date',
                key: 'generationDate',
                dataIndex: 'generationDate',
                render: (item, record, index) => {
                    return (<div>{item ? moment(item).format(dateFormat) : ''}</div>)
                }
            },
            {
                title: 'Invoice Received Date',
                key: 'receivedDate',
                dataIndex: 'receivedDate',
                render: (item, record) => {
                    if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate) {
                        return (<div>{moment(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate).format(dateFormat)}</div>)
                    } else {
                        return 'NA';
                    }
                }
            },
            {
                title: 'Invoice Added Date',
                key: 'addedDate',
                dataIndex: 'addedDate',
                render: (item, record) => {
                    if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate) {
                        return (<div>{moment(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate).format(dateFormat)}</div>)
                    } else {
                        return 'NA';
                    }
                }
            },
            {
                title: 'Invoice Status',
                key: 'invoiceStatus',
                dataIndex: 'invoiceStatus',
                render: (item, record) => {
                    let invoiceStatusClass = '#ffcc00';
                    if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined) {
                        if (['Paid by Uni', 'Cleared'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = 'green';
                        } else if (['Approved by Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = 'blue';
                        } else if (['Generated', 'Submitted to Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = '#ffcc00';
                        }
                    }
                    if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus) {
                        return (<div style={{ backgroundColor: invoiceStatusClass, color: 'white', padding: '10px', borderRadius: '10px', textAlign: 'center' }}>{generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus}</div>)
                    } else {
                        return 'NA';
                    }
                }
            },
            {
                title: 'Upload AP Invoice',
                key: 'apUploadInvoice',
                render: (item, record) => {
                    return (
                        <div>
                            {
                                record.apUploadInvoice && record.apUploadInvoice[0] && record.apUploadInvoice[0].url ?
                                    <p><b>AP Invoice: </b><a target='_blank' href={API_URL + '' + record.apUploadInvoice[0].url}>View</a></p>
                                    : null
                            }
                            {
                                record.apInvoiceNumber ?
                                    <p><b>AP Invoice Number: </b>{record.apInvoiceNumber}</p>
                                    : null
                            }
                            {
                                record.apReceiptUpload && record.apReceiptUpload[0] && record.apReceiptUpload[0].url ?
                                    <p><b>AP Receipt: </b><a target='_blank' href={API_URL + '' + record.apReceiptUpload[0].url}>View</a></p>
                                    : null
                            }
                            <Button onClick={(e) => {
                                this.setState({
                                    studentId: currentEditRecord._id,
                                    invoiceGeneratedId: record._id,
                                    showGeneratedInvoiceData: true
                                }, () => {
                                    setTimeout(() => {
                                        this.props.form.setFieldsValue({
                                            apUploadInvoice: record.apUploadInvoice,
                                            apInvoiceNumber: record.apInvoiceNumber,
                                            apReceiptUpload: record.apReceiptUpload,
                                        });
                                    }, 1000)
                                })
                            }} icon={<UploadOutlined />}>
                                {
                                    record.apInvoiceNumber ? 'Update' : 'Upload'}
                            </Button>
                        </div>
                    )
                }
            },
        ];

        const inputSchema2 = {
            fields: [
                {
                    label: 'AP Upload Invoice',
                    key: 'apUploadInvoice',
                    type: 'file',
                },
                {
                    label: 'AP Invoice Number',
                    key: 'apInvoiceNumber',
                    type: 'text',
                },
                {
                    label: 'AP Receipt Invoice',
                    key: 'apReceiptUpload',
                    type: 'file',
                }
            ]
        }

        return (

            <PageHeaderWrapper title={` Sub Agent Students : ${this.state.count} `} >
                <Card style={{ marginBottom: 10 }}
                    title="Search Filters"
                    headStyle={{ paddingTop: '5px' }}
                    bordered={false}>
                    <Row>
                        <Col span={8}>
                            <label>Filter By Invoice Status</label>
                            <Select
                                allowClear
                                style={{
                                    width: '90%',
                                    marginRight: 16
                                }}
                                showSearch={true}
                                className={common.width100Pr}
                                placeholder="Select Option"
                                optionFilterProp="display"
                                onChange={invoiceStatus => {
                                    this.setState(
                                        {
                                            invoiceStatus
                                        },
                                        () => {
                                            setTimeout(() => {
                                                this.table.current.reload()
                                            }, 500);
                                        }
                                    );
                                }}>
                                {invoiceStatusList.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val}>
                                            {val}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={8}>
                            <h4>Search By Invoice Date</h4>
                            <DatePicker onChange={this.chooseRangerPickerInvoiceDesk} style={{ width: '90%' }} />
                        </Col>
                        <Col span={8}>
                            <h4>Search By University</h4>
                            <Select
                                allowClear
                                style={{ width: '90%' }}
                                showSearch={true}
                                placeholder="Select University"
                                optionFilterProp="universityInstitutionName"
                                onChange={(v) => this.setState({ universityInstitutionName: v }, () => { this.table.current.reload(); })}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {
                                    universities.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.display}
                                            </Option>
                                        );
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={8}>
                            <h4>Search By Channel Partner</h4>
                            <Select
                                allowClear
                                style={{ width: '90%' }}
                                showSearch={true}
                                placeholder="Select Channel Partner"
                                optionFilterProp="channelPartnerId"
                                onChange={(v) => this.setState({ channelPartnerId: v }, () => { this.table.current.reload(); })}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {
                                    channelPartners.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.display}
                                            </Option>
                                        );
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={8}>
                            <h4>Search By Sub Agents</h4>
                            <Select
                                allowClear
                                style={{ width: '90%' }}
                                showSearch={true}
                                placeholder="Select Sub Agents"
                                optionFilterProp="associativePartnerId"
                                onChange={(v) => this.setState({ associativePartnerId: v }, () => { this.table.current.reload(); })}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {
                                    allSubAgents && allSubAgents.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val.value}>
                                                {val.text}
                                            </Option>
                                        );
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        id={'claimDesk'}
                        showSelector={true}
                        get che
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 2400 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

                <Drawer
                    title=""
                    placement="right"
                    closable={true}
                    id={'drawerCtrl'}
                    onClose={() => {
                        this.setState({
                            showReceiptDetails: false,
                            generatedInvoice: null,
                            invoiceDates: false
                        })
                    }}
                    visible={this.state.showReceiptDetails}
                    width={1200}>
                    <div style={{ marginLeft: 20, marginRight: 20, marginTop: 20, textAlign: 'center' }}>
                        {
                            invoiceDates && invoiceDates.length > 0 &&
                            <Col span={24} className={styles.bgTableBox}>
                                <Table
                                    rowKey={(item, x) => {
                                        return x
                                    }}
                                    className={styles.claimEdit}
                                    dataSource={invoiceDates || []}
                                    columns={invoiceColumns}
                                    pagination={false}
                                    border={true}
                                />
                            </Col>
                        }
                        {
                            generatedInvoice ?
                                <div id='table_with_data' style={{ marginTop: '20px', clear: 'both' }}>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <ShowGeneratedInvoice generatedInvoice={generatedInvoice} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                : null
                        }
                        <Drawer
                            title="Update AP Invoice Information"
                            placement="right"
                            closable={true}
                            id={'drawerCtrl2'}
                            onClose={() => {
                                this.setState({
                                    showGeneratedInvoiceData: false,
                                    studentId: '',
                                    invoiceGeneratedId: '',
                                })
                            }}
                            visible={showGeneratedInvoiceData}
                            width={600}>
                            <Form onSubmit={this.handleSubmit} style={{ paddingRight: '50px' }}>
                                <GetAllFormFields
                                    apiurl={API_URL}
                                    inputSchema={inputSchema2}
                                    getFieldDecorator={getFieldDecorator}
                                    formItemLayout={{
                                        labelCol: { span: 16 },
                                        wrapperCol: { span: 8 }
                                    }}
                                />
                                <div style={{ textAlign: 'center', width: '100%' }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{
                                            backgroundColor: '#85CF4A',
                                            border: '1px solid #85CF4A',
                                            color: 'white',
                                            marginTop: '15px'
                                        }}
                                        loading={this.props.loading}>
                                        Save
                                    </Button>
                                </div>
                            </Form>
                        </Drawer>
                    </div>
                </Drawer>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubAgentStudents)
